import React from 'react';
import { connect } from 'react-redux';
import MarkUp from '../components/MarkUp';

import { getTermsAndConditions } from '../redux/modules/user/action';

class Terms extends React.Component {
  state = {
    message: null
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getTermsAndConditions());
  }

  render() {
    const { termsCont } = this.props;
    return (
      <React.Fragment>
        <h3>{termsCont.title}</h3>
        <MarkUp html={termsCont && termsCont.description}/>
        <div className="foter">
          <p> Copyright 2019 © RoomerResume. All Rights Reserved.</p>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  termsCont: state.user.termsCont
});

export default connect(mapStateToProps)(Terms);